import React, { FunctionComponent } from 'react';

import { DIRECTION } from '@/types/common';

import { ArrowSVG } from './styles';

/**
 * @param size
 * @default 20
 *
 * @param direction
 * @default DIRECTION.RIGHT
 */
interface ArrowProps {
  size?: number;
  direction?: DIRECTION;
  fill?: string;
}
const Arrow: FunctionComponent<ArrowProps> = ({
  size = 20,
  direction = DIRECTION.RIGHT,
  fill = '#71767A',
}) => {
  return (
    <ArrowSVG
      direction={direction}
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.94723 3.34139C6.79298 3.37016 6.65153 3.46421 6.56349 3.59654C6.50157 3.6896 6.47584 3.77119 6.47142 3.88853C6.46597 4.03351 6.49103 4.12869 6.56462 4.24248C6.58365 4.2719 7.19476 4.88598 9.44798 7.13982L12.3072 9.99982L9.44798 12.8598C7.19476 15.1137 6.58365 15.7277 6.56462 15.7572C6.49103 15.8709 6.46597 15.9661 6.47142 16.1111C6.47468 16.1974 6.48713 16.2542 6.51781 16.3224C6.58073 16.4623 6.7185 16.5875 6.86388 16.6369C6.99749 16.6824 7.17399 16.6736 7.29639 16.6155C7.40291 16.5649 7.19523 16.769 10.3504 13.6138C12.0337 11.9305 13.2888 10.6713 13.3094 10.6452C13.5554 10.3338 13.6034 9.91058 13.4331 9.55448C13.3984 9.48186 13.3562 9.41373 13.3094 9.35449C13.2888 9.32838 12.0337 8.06916 10.3504 6.38588C7.79324 3.82863 7.42154 3.45889 7.38176 3.43286C7.27641 3.3639 7.19515 3.33851 7.0699 3.33541C7.01397 3.33402 6.97706 3.33582 6.94723 3.34139Z"
        fill={fill}
      />
    </ArrowSVG>
  );
};

export default Arrow;
